// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"3d9078bd","324":"5fa3e226","666":"65cf6fb6","800":"26bae506","802":"a083366a","956":"5580a02b","972":"6e4c997f"}[chunkId] + ".chunk.js";
};